module.exports = __webpack_public_path__ + "img/profile_corvus@2x.75281568.png";